import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getFormValues, reduxForm, Field, Form, change } from 'redux-form';
import { compose } from 'redux';
import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import BasicTextArea from '../../../../../shared/components/formComponents/groups/BasicTextArea';
import BasicNumericInput from '../../../../../shared/components/formComponents/groups/BasicNumericInput';
import RawImageUpload from '../../../../../shared/components/formComponents/inputs/RawImageUpload';
import FormFeedback from '../../../../../shared/components/formComponents/FormFeedback';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import DimensionAbilitiesTable from './DimensionAbilitiesTable';

class DimensionForm extends PureComponent {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool.isRequired,
        onCancel: PropTypes.func,
        abilitiesById: PropTypes.object,
        changeFormValue: PropTypes.func,
        currentValues: PropTypes.object
    };

    render() {
        const { submitting, handleSubmit, onCancel, currentValues = {}, changeFormValue, abilitiesById } = this.props;
        return (
            <Form className={'dimension-form'} onSubmit={handleSubmit}>
                <Field
                    component={BasicText}
                    name={'name'}
                    label={'Dimension Name'}
                    className={'row'}
                    inputClassName={'col-12 col-sm-5 no-padding'}
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                    maxLength={40}
                />
                <Field
                    component={BasicText}
                    name={'subtitle'}
                    label={'Dimension Subtitle'}
                    className={'row'}
                    inputClassName={'col-12 col-sm-5 no-padding'}
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                    maxLength={160}
                />
                <Field
                    component={BasicTextArea}
                    name={'description'}
                    label={'Dimension description'}
                    className={'row'}
                    inputClassName={'col-12 col-sm-5 no-padding'}
                    styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                    maxLength={420}
                />
                <Field
                    component={BasicNumericInput}
                    name={'rank'}
                    label={'Ranking'}
                    className={'row'}
                    inputClassName={'col-12 col-sm-2'}
                    styleProps={{ horizontal: true, inputStyle: { 'full-width': true } }}
                />
                <Field
                    component={RawImageUpload}
                    name={'headerImageUrl'}
                    label={'Dimension Header'}
                    className={'row'}
                    cropProp={{ width: 100, height: 100 }}
                    inputClassName={''}
                    buttonClassName={'col-12 col-sm-5'}
                    styleProps={{ horizontal: true }}
                />
                <Field
                    component={RawImageUpload}
                    name={'thumbnailImageUrl'}
                    label={'Dimension Image'}
                    className={'row'}
                    cropProp={{ width: 150, height: 100 }}
                    inputClassName={''}
                    buttonClassName={'col-12 col-sm-5'}
                    styleProps={{ horizontal: true }}
                />
                <DimensionAbilitiesTable
                    abilitiesById={abilitiesById}
                    currentValues={currentValues}
                    changeFormValue={changeFormValue}
                />
                <div className={'col-12 formButtons'}>
                    <VerbButton
                        fontAwesomeIcon={'fa-save'}
                        textId={'BUTTON_SAVE'}
                        defaultMessage={'SAVE'}
                        onClick={handleSubmit}
                        disabled={submitting}
                    />
                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                        fontAwesomeIcon={'fa-ban'}
                        textId={'BUTTON_CANCEL'}
                        defaultMessage={'CANCEL'}
                        onClick={onCancel}
                        disabled={submitting}
                    />
                </div>
                <FormFeedback {...this.props} className={'col-12'} />
            </Form>
        );
    }
}

export const DimensionFormComponent = DimensionForm;

const DimensionFormValidation = {
    form: 'Dimension',
    enableReinitialize: true
};

const mapStateToProps = (state, ownProps) => {
    const { name, description, thumbnailImageUrl, headerImageUrl, rank, abilityIds, subtitle } =
        ownProps.currentDimension;
    return {
        initialValues: {
            name,
            description,
            thumbnailImageUrl,
            headerImageUrl,
            rank,
            subtitle,
            abilityIds
        },
        currentValues: getFormValues('Dimension')(state)
    };
};

const mapDispatchToProps = (dispatch) => ({
    changeFormValue: (params) => dispatch(change('Dimension', params.field, params.value))
});

export default compose(connect(mapStateToProps, mapDispatchToProps), reduxForm(DimensionFormValidation))(DimensionForm);
